import { Box } from "@outschool/backpack";
import {
  useLogSearchImpression,
  useProductListViewed
} from "@outschool/ui-analytics";
import { MiniListing as MobileListingCard } from "@outschool/ui-components-website";
import { Container } from "@outschool/ui-legacy-component-library";
import { useIsMobile, useNavigation } from "@outschool/ui-utils";
import React from "react";

import { SearchListingsQuery } from "../../../shared/generated/graphql";
import * as Routes from "../../../shared/Routes";
import CardGrid from "../categories/CardGrid";
import Link from "../Link";

// Used in Tutoring
const TutoringListings = ({
  listings,
  showAll,
  searchUid,
  variant,
  pageLocation
}: {
  listings: SearchListingsQuery["searchListings"]["listings"];
  showAll: boolean;
  searchUid: string;
  variant?: string;
  useSushiCardOnMoblie?: boolean;
  pageLocation: string;
}) => {
  const trackProductListViewed = useProductListViewed();
  const displayListings = showAll ? listings : listings.slice(0, 8);
  const isMobile = useIsMobile();

  React.useEffect(() => {
    if (!listings?.length) {
      return;
    }

    const label = isMobile ? "mobile" : "desktop";

    // @ts-ignore TS(2345): Argument of type '{ __typename?: "Listing" | undef... Remove this comment to see the full error message
    trackProductListViewed("tutoring-page", label, listings);
  }, [isMobile, listings, trackProductListViewed]);

  return (
    <Container>
      {isMobile ? (
        <Box>
          {displayListings.map((listing, index) => (
            <Box
              key={index}
              sx={{
                paddingBottom: "1em"
              }}
            >
              <TutoringListing
                listing={listing}
                listingIndex={index}
                variant={variant}
                pageLocation={pageLocation}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <CardGrid
          listings={displayListings}
          pageLocation={pageLocation}
          rowCount={showAll ? 5 : 2}
          trackingLabel="tutoring_page_listings_desktop"
          trackingProperties={{
            searchUid
          }}
          // @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
          variant={variant}
          openInSSRForLoggedOutUsers
        />
      )}
    </Container>
  );
};

export function TutoringListing({
  listing,
  listingIndex,
  variant,
  pageLocation
}: $TSFixMe) {
  const navigate = useNavigation();
  const { trackSearchImpressionClick, searchImpressionRef } =
    useLogSearchImpression({ listing, listingIndex, pageLocation });

  return (
    <Link
      ref={searchImpressionRef}
      to={Routes.activityPath(listing.activity)}
      onClick={(e: $TSFixMe) => {
        e.preventDefault();
        trackSearchImpressionClick();
        // Hard navigate so a full page load opens SSR.
        navigate(Routes.activityPath(listing.activity), {
          hardNav: true
        });
      }}
      trackingName="catalog_hub_listings_desktop_mobile"
      trackingUniqueId={listing.activity.uid}
      sharedProperties={{
        insertion_id: listing.insertionId,
        order: listingIndex
      }}
    >
      <MobileListingCard
        listing={listing}
        showFrequency={false}
        listingIndex={listingIndex}
        variant={variant}
      />
    </Link>
  );
}

export default TutoringListings;
